import { CardStyleInterpolators, createStackNavigator } from "@react-navigation/stack";
import { observer } from "mobx-react";
import React from "react";
import { Dimensions } from "react-native";
import NotarizeDispute from "../screens/dispute/NotarizeDispute";
import ViewNotarizeDetails from "../screens/document/ViewNotarizeDetails";
import ViewNotarizeDocuments from "../screens/document/ViewNotarizeDocuments";
import ViewPOIDocument from "../screens/document/ViewPOIDocument";
import AuthNavigator from "./AuthNavigator";
import DashboardNavigator from "./DashboardNavigator";

const Stack = createStackNavigator();
const { width, height } = Dimensions.get("window");

const globalConfig = {
  headerShown: false,
  cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
};

const config = {
  headerShown: false,
  cardStyleInterpolator: CardStyleInterpolators.forVerticalIOS,
};

const RootNavigator = observer(({ uid }) => {
  const docConfig = {
    gestureDirection: "vertical",
    headerShown: false,
    cardStyleInterpolator: CardStyleInterpolators.forModalPresentationIOS,
    // animationEnabled: true,
  };
  return (
    <Stack.Navigator initialRouteName={"auth"}>
      {uid ? (
        <>
          <Stack.Screen name="dashboard" component={DashboardNavigator} options={{ headerShown: false }} />
          <Stack.Screen name="viewpoidocument" component={ViewPOIDocument} options={docConfig} />
          <Stack.Screen name="viewnotarizedocuments" component={ViewNotarizeDocuments} options={docConfig} />
          <Stack.Screen name="notarizedispute" component={NotarizeDispute} options={{ headerShown: false }} />
          <Stack.Screen
            name="viewnotarizedetails"
            component={ViewNotarizeDetails}
            options={{
              ...docConfig,
              cardStyleInterpolator: CardStyleInterpolators.forVerticalIOS,
            }}
          />
        </>
      ) : (
        <Stack.Screen name="auth" component={AuthNavigator} options={{ headerShown: false }} />
      )}
    </Stack.Navigator>
  );
});

export default RootNavigator;
